import { HOME_CONTENT, HOME_RIGHT_NOW_CONTENT, HomeContentDto } from "@modules/home/gateway/homeApiDto"

type HomeContentState = Pick<HomeContent, "title" | "content">

export class HomeContent {
  title: string
  content: HomeContentDto["content"]

  constructor(homeContent: HomeContentState) {
    this.title = homeContent.title
    this.content = homeContent.content
  }

  static fromDto(homeContentDto: HomeContentDto): HomeContent {
    return new HomeContent({
      title: homeContentDto.title,
      content: homeContentDto.content,
    })
  }

  getRightNowDescription(): string | undefined {
    const rightNowContent = this.content.find((content) => content._type === HOME_CONTENT.RIGHT_NOW)
    if (rightNowContent && "description" in rightNowContent) return rightNowContent.description
    return ""
  }

  shouldDisplayEvents(): boolean {
    const rightNowContent = this.content.find((content) => content._type === HOME_CONTENT.RIGHT_NOW)

    return (
      !!rightNowContent && "content" in rightNowContent && rightNowContent.content === HOME_RIGHT_NOW_CONTENT.EVENTS
    )
  }

  shouldDisplayRightNowSection(): boolean {
    const rightNowContent = this.content.find((content) => content._type === HOME_CONTENT.RIGHT_NOW)

    return !!rightNowContent && "content" in rightNowContent && rightNowContent.content !== HOME_RIGHT_NOW_CONTENT.NONE
  }
}
